import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "creditCard"
const CreditCardIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.667 4A2.667 2.667 0 0 0 2 6.667v10.666A2.667 2.667 0 0 0 4.667 20h14.666A2.667 2.667 0 0 0 22 17.333V6.667A2.667 2.667 0 0 0 19.333 4H4.667ZM5 8v2h14V8H5Zm0 4v2h8v-2H5Z"
          />
        </svg>
      }
    </span>
  )
}
export default CreditCardIcon
